module.exports = __webpack_public_path__ + "static/img/ent-detail-73.fc6c5ec.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-detail-73.jpg
// module id = kkuH
// module chunks = 52